import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class TablasDinamicasConfigService {

  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tramites-automaticos`;
  }

  getFormularioDataset(tablaDinamicaId: number, columnName: string, columnValue: string): Observable<Record<string, any>[]> {
    const params = new HttpParams()
      .set('columnName', columnName)
      .set('columnValue', columnValue);

    return this.http.get<Record<string, any>[]>(`${this.baseUrl}/tablas-dinamicas/get-formulario-dataset/${tablaDinamicaId}`, { params });
  }
}
